import { ScoreColorVariant } from '@vizit/constants';
import { cva } from '@vizit/theme';
import { ScoreStickerSize } from './types';

const wrapperClasses = cva({
  base: 'inline-flex items-center justify-center p-px shrink-0',
  variants: {
    colorVariant: {
      [ScoreColorVariant.NotApplicable]: 'bg-gray-utility-300',
      [ScoreColorVariant.VeryLow]: 'bg-error-400',
      [ScoreColorVariant.Low]: 'bg-error-400',
      [ScoreColorVariant.Moderate]: 'bg-warning-300',
      [ScoreColorVariant.High]: 'bg-green-yellow-300',
      [ScoreColorVariant.VeryHigh]: 'bg-success-200',
    },
    size: {
      [ScoreStickerSize.Lg]: 'h-64 w-64',
      [ScoreStickerSize.Sm]: 'h-32 w-32',
      [ScoreStickerSize.Xs]: '',
    },
  },
});

const innerClasses = cva({
  base: '',
  variants: {
    colorVariant: {
      [ScoreColorVariant.NotApplicable]: 'bg-gray-utility-50',
      [ScoreColorVariant.VeryLow]: 'bg-error-50',
      [ScoreColorVariant.Low]: 'bg-error-50',
      [ScoreColorVariant.Moderate]: 'bg-warning-50',
      [ScoreColorVariant.High]: 'bg-green-yellow-50',
      [ScoreColorVariant.VeryHigh]: 'bg-success-50',
    },
    size: {
      [ScoreStickerSize.Lg]: 'flex flex-1 flex-col items-center h-full rounded-xl',
      [ScoreStickerSize.Sm]: 'flex flex-1 flex-col items-center h-full justify-center rounded-sm',
      [ScoreStickerSize.Xs]: 'inline-flex items-center justify-center rounded-sm h-19 w-19',
    },
  },
});

const textColorClasses = cva({
  base: '',
  variants: {
    colorVariant: {
      [ScoreColorVariant.NotApplicable]: 'text-gray-utility-700',
      [ScoreColorVariant.VeryLow]: 'text-error-900',
      [ScoreColorVariant.Low]: 'text-error-900',
      [ScoreColorVariant.Moderate]: 'text-warning-900',
      [ScoreColorVariant.High]: 'text-green-yellow-900',
      [ScoreColorVariant.VeryHigh]: 'text-success-900',
    },
  },
});

const textSizeClasses = cva({
  base: 'text-center font-serif-text font-light',
  variants: {
    size: {
      [ScoreStickerSize.Lg]: 'text-display-xl leading-none',
      [ScoreStickerSize.Sm]: 'text-display-md',
      [ScoreStickerSize.Xs]: 'text-display-xs',
    },
    isNa: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      isNa: true,
      size: ScoreStickerSize.Sm,
      className: 'text-display-sm',
    },
    {
      isNa: true,
      size: ScoreStickerSize.Xs,
      className: 'text-sm',
    },
  ],
});

const skeletonClasses = cva({
  base: '',
  variants: {
    size: {
      [ScoreStickerSize.Lg]: 'h-64 w-64',
      [ScoreStickerSize.Sm]: 'h-32 w-32',
      [ScoreStickerSize.Xs]: 'h-19 w-19',
    },
  },
});

export { wrapperClasses, innerClasses, textColorClasses, textSizeClasses, skeletonClasses };
